import React from 'react'
import { useInView } from 'react-intersection-observer'
import { useSelector } from 'react-redux'
import Helmet from 'react-helmet'
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'

import Accordion from '../accordion'
import Wysiwyg from '../wysiwyg'

import plusIcon from '../../icons/plus.svg'
import minusIcon from '../../icons/minus.svg'

import roundShape from '../../icons/round-shape.svg'
import hexagonShape from '../../icons/hexagon-shape.svg'
import semiroundShape from '../../icons/semiround-shape.svg'

import trads from '../../intl/trads.json'

const Faq = ({data}) => {
  const { ref, inView} = useInView({ threshold: 0.25, triggerOnce: true})
  const lang = useSelector(state => state.lang)
  
  const items = (data.faqItems) ? data.faqItems : data.items
  const title = (data.faqTitle) ? data.faqTitle : trads[lang].faq.title

  const helmetDatas = []

  items.forEach(faq => {
    const item = (faq.fields) ? faq.fields : faq
    const question = (faq.fields) ? item.question : item.question.question 
    const answer = (faq.fields) ? item.answer : JSON.parse(item.answer.raw)

    const helmetObject = {
      "@type": "Question",
      "name": question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": documentToPlainTextString(answer)
      }
    }

    helmetDatas.push(JSON.stringify(helmetObject))
  })

  return (
    <div className={inView ? 'has-anim' : ''} ref={ref}>
      { title &&
        <h2 className="title title-slice mb-8 scroll-anim-el">{title}</h2>
      }
      
      <div className="contact-questions">
        <svg className={`absolute icon-gradient-sienne contact-questions__hexagon`} width="200px" height="200px">
          <use xlinkHref={hexagonShape.url} />
        </svg>
        <svg className={`absolute icon-orange contact-questions__semiround`} width="127px" height="142px">
          <use xlinkHref={semiroundShape.url} />
        </svg>
        <svg className={`absolute icon-beige contact-questions__round`} width="57px" height="57px">
          <use xlinkHref={roundShape.url} />
        </svg>

        <div className="scroll-anim-el scroll-anim-el--2">
          { items.map((faq, i) => {
            const item = (faq.fields) ? faq.fields : faq
            const question = (faq.fields) ? item.question : item.question.question 
            const answer = item.answer

            return (
              <Accordion 
                key={i}
                prefixClass="accordion-slice"
                iconClosed={plusIcon.url}
                iconOpen={minusIcon.url}
                button={question}
                type="title"
                titleLevel={title ? 3 : 2} >
                  <Wysiwyg document={answer} />
                </Accordion>
            )
          }) }
        </div>
      </div>

      <Helmet>
        <script type="application/ld+raw">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [${helmetDatas}]
          }
        `}</script>
      </Helmet>
    </div>
  )
}

export default Faq